module.exports = __webpack_public_path__ + "img/DE01739.82bca21b.svg";